/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ site: NonNullable<unknown>, value: NonNullable<unknown> }} Body_Measures_SavedInputs */

const en_us2_body_measures_saved = /** @type {(inputs: Body_Measures_SavedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.site}: ${i?.value} cm logged`)
};

const pt_br2_body_measures_saved = /** @type {(inputs: Body_Measures_SavedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.site}: ${i?.value} cm registrado`)
};

const es_419_body_measures_saved = /** @type {(inputs: Body_Measures_SavedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.site}: ${i?.value} cm registrado`)
};

const pt_pt2_body_measures_saved = /** @type {(inputs: Body_Measures_SavedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.site}: ${i?.value} cm registado`)
};

const fr_fr2_body_measures_saved = /** @type {(inputs: Body_Measures_SavedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.site} : ${i?.value} cm enregistré`)
};

const de_de2_body_measures_saved = /** @type {(inputs: Body_Measures_SavedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.site}: ${i?.value} cm eingetragen`)
};

const it_it2_body_measures_saved = /** @type {(inputs: Body_Measures_SavedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.site}: ${i?.value} cm registrati`)
};

/**
* | output |
* | --- |
* | "{site}: {value} cm logged" |
*
* @param {Body_Measures_SavedInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const body_measures_saved = /** @type {((inputs: Body_Measures_SavedInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Body_Measures_SavedInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_body_measures_saved(inputs)
	if (locale === "es-419") return es_419_body_measures_saved(inputs)
	if (locale === "pt-PT") return pt_pt2_body_measures_saved(inputs)
	if (locale === "fr-FR") return fr_fr2_body_measures_saved(inputs)
	if (locale === "de-DE") return de_de2_body_measures_saved(inputs)
	if (locale === "it-IT") return it_it2_body_measures_saved(inputs)
	return en_us2_body_measures_saved(inputs)
});
export { body_measures_saved as "body-measures.saved" }